/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SalesDetailReqRecord } from './SalesDetailReqRecord';
import type { UssdBankRecord } from './UssdBankRecord';

/**
 * Class used to define the bank chosen for the USSD payment
 */
export type OperationReqUssdDTO = {
    /**
     * Currency of the operation
     */
    currency: OperationReqUssdDTO.currency;
    saleItemDetail: Array<SalesDetailReqRecord>;
    ussdBank: UssdBankRecord;
};

export namespace OperationReqUssdDTO {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
